var _rect, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDeleteBtn(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    rx: 4,
    fill: "#12BFE0"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4402_6523)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.76456 13.5786C6.76456 14.1718 7.24985 14.6571 7.84299 14.6571H12.1567C12.7499 14.6571 13.2351 14.1718 13.2351 13.5786V7.10803H6.76456V13.5786ZM8.09103 9.73941L8.85132 8.97911L9.99985 10.1222L11.143 8.97911L11.9033 9.73941L10.7601 10.8825L11.9033 12.0257L11.143 12.786L9.99985 11.6428L8.85671 12.786L8.09642 12.0257L9.23956 10.8825L8.09103 9.73941ZM11.8871 5.49039L11.3479 4.95117H8.65181L8.1126 5.49039H6.22534V6.56882H13.7744V5.49039H11.8871Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4402_6523"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12.9412,
    height: 12.9412,
    fill: "white",
    transform: "translate(3.5293 3.3335)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteBtn);
export default __webpack_public_path__ + "static/media/deleteBtn.892ccaede2807c2561be92273d4dbb22.svg";
export { ForwardRef as ReactComponent };